import { createContext, Dispatch, ReactNode, useContext, useReducer } from "react"
import reducer, { StoreState, initialState } from "./reducer"
import { StoreAction } from "../../../types/store"

interface StoreContext {
  statePlayers: StoreState
  dispatchPlayers: Dispatch<StoreAction>
}

export const Store = createContext<StoreContext>({
  statePlayers: initialState,
  dispatchPlayers: () => undefined,
})

export function useStorePlayers(): StoreContext {
  return useContext(Store)
}

interface Props {
  children: ReactNode | ReactNode[]
}

export function StoreProviderPlayers({ children }: Props) {
  const [statePlayers, dispatchPlayers] = useReducer(reducer, initialState)

  return <Store.Provider value={{ statePlayers, dispatchPlayers }}>{children}</Store.Provider>
}
